import { Button } from "design_system";
import useFilterDrawer from "features/FilterDrawer/hooks/useFilterDrawer";
import useFilters from "features/FilterDrawer/hooks/useFilters";
import pluralize from "helpers/pluralize";
import useLabels from "hooks/useLabels";
import { ListFilter } from "lucide-react";
import { MouseEvent } from "react";

function FilterButton({
  hideLabelForMobile = false,
}: {
  hideLabelForMobile?: boolean;
}) {
  const [labels] = useLabels("features.filter-drawer.filter-button");

  const { openFilterDrawer } = useFilterDrawer();

  const handleOpenFilterDrawer = (event: MouseEvent<HTMLElement>) => {
    event.preventDefault();
    openFilterDrawer();
  };

  const { appliedFilterCount } = useFilters();

  return (
    <Button
      variant="flat"
      size="sm"
      iconLeft={<ListFilter />}
      onClick={handleOpenFilterDrawer}
      data-testid="filter-button"
      hideLabelForMobile={hideLabelForMobile}
      className={hideLabelForMobile ? "w-9 sm:w-auto" : undefined}
    >
      {pluralize(labels["filter"], {
        FILTER_COUNT: appliedFilterCount,
      })}
    </Button>
  );
}

export default FilterButton;
